/*
 * @Author: zyq yqzhang01@gongsibao.com
 * @Date: 2022-08-16 09:47:08
 * @LastEditors: zyq yqzhang01@gongsibao.com
 * @LastEditTime: 2022-08-29 16:50:26
 * @FilePath: \fe-frame-page\src\utils\znRequest.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from "axios";
import { encrypt } from "./crypto";
import { message } from "ant-design-vue";

const request = axios.create({
  baseURL:
    process.env.NODE_ENV === "development"
      ? "/znApi"
      : process.env.VUE_APP_ZN_URL,
  timeout: 6000,
});

// request 拦截器
request.interceptors.request.use(
  (config) => {
    config.headers["Content-Type"] = "application/json";
    config.headers["Accept"] = "application/json; charset=utf-8";
    if (sessionStorage.getItem("uid")) {
      const signData = {
        userId: sessionStorage.getItem("uid"),
        username: sessionStorage.getItem("tel"),
        orgId: sessionStorage.getItem("cid"),
        orgName: decodeURIComponent(sessionStorage.getItem("corp")),
      };
      let app_key = "";
      let app_secret = "";
      if (sessionStorage.getItem("page") == "ICompany") {
        // IC
        app_key = process.env.VUE_APP_IC_KEY;
        app_secret = process.env.VUE_APP_IC_SECRET;
      } else if (sessionStorage.getItem("page") == "Official") {
        // 官网
        app_key = process.env.VUE_APP_GW_KEY;
        app_secret = process.env.VUE_APP_GW_SECRET;
      } else if (sessionStorage.getItem("page") == "corp") {
        app_key = process.env.VUE_APP_ZQ_KEY;
        app_secret = process.env.VUE_APP_ZQ_SECRET;
      }
      console.log(111,app_key)

      const { sign, timestamp } = encrypt(signData, app_key, app_secret);

      config.headers.sign = sign;
      config.headers.timestamp = timestamp;
      config.headers.appKey = app_key;
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

// response 拦截器
request.interceptors.response.use(
  (response) => {
    const code = response.status;
    const res = response.data;
    // 这里处理一些response 正常放回时的逻辑
    if (code < 200 || code > 300) {
      message.error(res.data.message);
      return Promise.reject(response);
    } else {
      return res;
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);
export default request;
